import builder from '../builder';
import Hyperlink2 from '../../streamline-icons/light/hyperlink-2.svg';

export default builder('IconHyperlink2Light', Hyperlink2);
